export function familyNameDefault (contact) {
  if (!contact) return 'New Household'
  const last = (contact.last_name ?? '').trim()
  if (last) return `${last} Household`
  const first = (contact.first_name ?? '').trim()
  if (first) return `${first} Household`
  return 'New Household'
}

export function contactDisplayName (contact) {
  if (!contact) return ''
  const full = (contact.full_name ?? '').trim()
  if (full) return full
  const combined = [contact.first_name, contact.last_name].filter(Boolean).join(' ').trim()
  if (combined) return combined
  return contact.id ? `Contact #${contact.id}` : ''
}

// Returns null when the error isn't a recognized link-redtail-client 409.
export function normalizeLinkConflict (error) {
  const status = error?.response?.status ?? error?.statusCode
  if (status !== 409) return null

  const payload = error?.response?.data?.data ?? error?.data ?? null
  if (!payload || payload.type !== 'redtail-family-already-linked') return null

  return {
    type: payload.type,
    familyId: payload.familyId ?? null,
    familyName: payload.familyName ?? null,
    existingLinks: Array.isArray(payload.existingLinks) ? payload.existingLinks : [],
    retryWith: payload.retryWith ?? { acknowledgeConflict: true }
  }
}
